import React, { useState } from "react";
import BackToGameList from "../../utils/BackToGameList";
import Card from "react-bootstrap/esm/Card";
import PreStart from "./PreStart";
import SquenceGame from "./SquenceGame";

function Sequences() {
  const [start, setStart] = useState(false);
  const [count, setCount] = useState(0);
  const [incorrectCount, setIncorrectCount] = useState(0);
  const [number, setNumber] = useState(0);

  return (
    <>
      <BackToGameList />
      <div
        className="main-content"
        style={{ margin: "20px", background: "rgb(240, 244, 249)" }}
      >
        <Card bg="light" style={{ marginTop: "50px" }}>
          <Card.Header>
            <h2>Sequences</h2>
          </Card.Header>
          <Card.Body>
            {start ? (
              <>
                <div>
                  Score: {count} | Number of times incorrect: {incorrectCount}
                </div>
                <SquenceGame
                  setCount={setCount}
                  setNumber={setNumber}
                  setIncorrectCount={setIncorrectCount}
                />
              </>
            ) : (
              <PreStart setStart={setStart} />
            )}
          </Card.Body>
        </Card>
      </div>
    </>
  );
}

export default Sequences;
